export default abstract class Utils {

  protected static numerlas = {
    1: 'Pierwszy',
    2: 'Drugi',
    3: 'Trzeci',
    4: 'Czwarty',
    5: 'Piąty',
    6: 'Szósty',
    7: 'Siódmy',
    8: 'Ósmy',
    9: 'Dziewiąty',
    10: 'Dziesiąty',
    11: 'Jedenasty',
    12: 'Dwunasty',
    13: 'Trzynasty',
    14: 'Czternasty',
    15: 'Piętnasty',
    16: 'Szesnasty',
    17: 'Siedemnasty',
    18: 'Osiemnasty',
    19: 'Dziewiętnasty',
    20: 'Dwudziesty'
  };

  public static numberDeclensionFormat(number: number): string {
    return `${this.numerlas[number]} numer`;
  }
}
